module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"line-qr-text":"Add LINE Friends\\n via QR Code"},"zh-TW":{"line-qr-text":"有任何問題歡迎透過Line聯繫我們"}}')
  delete Component.options._Ctor
}
